/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Content.ContainerAccessPolicy_
///   This is an auto-generated enumeration of the SWFC_Learning.Content.ContainerAccessPolicy domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum ContainerAccessPolicy_ {
   /// <summary>
   ///   Open (Open)
   /// </summary>
   Open = 0,
   /// <summary>
   ///   Guided (Guided)
   /// </summary>
   Guided = 1,
   /// <summary>
   ///   Guided Module (GuidedM)
   /// </summary>
   GuidedModule = 2,
   /// <summary>
   ///   Guided Lesson (GuidedL)
   /// </summary>
   GuidedLesson = 4
}

export const ContainerAccessPolicies: ContainerAccessPolicy[] = [
   {
      code: ContainerAccessPolicy_.Open,
      literal: 'Open',
      description: 'Open',
      shortDescription: 'Open',
      listPriority: 0,

      name: 'Open',

      typeName: "ContainerAccessPolicy"
   },
   {
      code: ContainerAccessPolicy_.Guided,
      literal: 'Guided',
      description: 'Guided',
      shortDescription: 'Guided',
      listPriority: 0,

      name: 'Guided',

      typeName: "ContainerAccessPolicy"
   },
   {
      code: ContainerAccessPolicy_.GuidedModule,
      literal: 'GuidedModule',
      description: 'Guided Module',
      shortDescription: 'GuidedM',
      listPriority: 0,

      name: 'GuidedModule',

      typeName: "ContainerAccessPolicy"
   },
   {
      code: ContainerAccessPolicy_.GuidedLesson,
      literal: 'GuidedLesson',
      description: 'Guided Lesson',
      shortDescription: 'GuidedL',
      listPriority: 0,

      name: 'GuidedLesson',

      typeName: "ContainerAccessPolicy"
   }
]

export class ContainerAccessPolicy implements IDomainModel {
   code: ContainerAccessPolicy_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   name: string

   typeName: string

   static toDomainModel(code: ContainerAccessPolicy_): ContainerAccessPolicy {
      return ContainerAccessPolicies.find(d => d.code === code)
   }
}
